import React, { useState, useEffect, useContext} from "react"
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import 'moment/locale/fr'
import {
  Box,
  Container,
  Button,
  Hidden,
} from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import {
  Box as BoxIcon,
} from 'react-feather';

import PageContentWrapper from "../PageContentWrapper"
import ScansContext from "../../contexts/ScansContext"

import SoftSkillsWrapper from "../ui/SoftSkillsWrapper"

moment.locale("fr");


const RecruiterScans = ({ }) => {
  const navigate = useNavigate();
  const { isLoaded, scans } = useContext(ScansContext)


  return (
    <PageContentWrapper
      title="Scans"
      buttonTitle="Créer"
      buttonIcon={<AddIcon/>}
      buttonOnClick={() => {
        navigate('/app/createScan')
      }}
      buttonDisabled={!isLoaded}
      onglets={[{
        title: "Tous",
        icon : <BoxIcon size="16px"/>,
        onClick : () => { },
      }]}
    >
      {(isLoaded === true && scans?.length > 0) &&
        <Box sx={{display:"flex", flexDirection:"column", flex:1, gap:["10px", "10px", "20px"], maxWidth:"100%", overflow:"hidden"}}>
          {scans?.map((item, index) => {
            let isPlayable = item?.playable
            return (
              <Box
                key={index}
                sx={{
                  background:"white",
                  border:"1px solid #E7E7E7",
                  cursor: isPlayable ? "pointer" : "default",
                  padding:["15px", "20px", "25px"],
                  opacity:isPlayable ? 1 : 0.6,
                  userSelect:"none",
                  "&:hover" : {
                    border:isPlayable ? "1px solid black" : "1px solid #E7E7E7",
                  },
                }}
                onClick={() => {
                  if(isPlayable) {
                    navigate('/app/scan/'+item?.id)
                  }
                }}
              >
                <Box sx={{width:"100%", height:"100%", display:"flex", justifyContent:"space-between", maxWidth:"100%", overflow:"hidden", gap:"20px"}}>
                  <Box sx={{
                    display:"flex",
                    columnGap:"15px",
                    flexWrap:["nowrap", "wrap", "wrap"],
                    flexDirection:["column", "row", "row"],
                    alignItems:["flex-start", "center", "center"],
                    flex:1,
                    maxWidth:"100%",
                    overflow:"hidden",
                    gap:isPlayable?"15px":"0px",
                  }}>
                    <Box sx={{display:"flex", flexDirection:"column", justifyContent:"center", maxWidth:"100%", overflow:"hidden"}}>
                      <Box sx={{
                        fontSize:["12px", "14px", "14px"],
                        fontWeight : 400,
                        color:"text.primary",
                        overflow:"hidden",
                        whiteSpace:"nowrap",
                        textOverflow:"ellipsis",
                      }}>
                        Crée le <span style={{textTransform:"capitalize"}}>{moment(item?.createdAt).format("LLLL")}</span>
                      </Box>
                      <Box sx={{
                        fontSize:["20px", "32px", "32px"],
                        fontWeight : 500,
                        color:"text.black",
                        textTransform:"capitalize",
                        marginTop:"3px",
                        overflow:"hidden",
                        whiteSpace:"nowrap",
                        textOverflow:"ellipsis",
                      }}>
                        {item.name}
                      </Box>
                    </Box>
                    {isPlayable === true ? (
                      <Box sx={{height:"40px", overflow:"hidden", display:"flex", alignItems:"flex-start", columnGap:"7px"}}>
                        <SoftSkillsWrapper
                          softSkills={item?.module?.softSkills?.filter((el) => el.value === "oui")}
                        />
                        {/*<Box sx={{overflow:"hidden", display:"flex", flexWrap:"wrap", columnGap:"7px", rowGap:"20px", marginTop:"5px"}}>
                          {item?.module?.softSkills?.filter((el) => el.value === "oui").map((skill, index) => {
                            let color = colorByFamily?.find((el) => el.family === skill?.family)
                            return (
                              <Box
                                key={index}
                                sx={{
                                  fontSize:["10px", "11px", "12px"],
                                  fontWeight:500,
                                  padding:["7px", "8px", "9px"],
                                  flexShrink:0,
                                  background : color?.bg,
                                  color: color?.text,
                                  border: `1px solid ${color?.border}`,
                                  textTransform:"uppercase",
                                  userSelect:"none",
                                }}
                              >
                                {skill?.key}
                              </Box>
                            )
                          })}
                        </Box>*/}
                      </Box>
                    ) : (
                      <Box sx={{flex:["auto", "auto", 1], height:"40px", overflow:"hidden", display:"flex", alignItems:"center", whiteSpace:"nowrap", textOverflow:"ellipsis", justifyContent:["flex-start", "flex-start", "center"]}}>
                        En cours d'analyse ...
                      </Box>
                    )}
                    <Hidden smUp>
                      <Box sx={{marginTop:"5px", paddingTop:"10px", borderTop:"1px solid #E7E7E7", display:"flex", justifyContent:"space-between", gap:"10px", width:"100%"}}>
                        <Box sx={{display:"flex", justifyContent:"space-around", flexShrink:0, gap:"3px", alignItems:"flex-end"}}>
                          <Box sx={{
                            fontSize:"19px",
                            color:"text.black",
                            fontWeight:500
                          }}>
                            {item?.invitedCounter}
                          </Box>
                          <Box sx={{
                            fontSize:"13px",
                            color:"text.primary",
                            fontWeight:400
                          }}>
                            Invités
                          </Box>
                        </Box>
                        <Box sx={{display:"flex",justifyContent:"space-around", flexShrink:0, gap:"3px", alignItems:"flex-end"}}>
                          <Box sx={{
                            fontSize:"19px",
                            color:"text.black",
                            fontWeight:500
                          }}>
                            {item?.completedCounter}
                          </Box>
                          <Box sx={{
                            fontSize:"13px",
                            color:"text.primary",
                            fontWeight:400
                          }}>
                            Complétés
                          </Box>
                        </Box>
                        <Box sx={{display:"flex",justifyContent:"space-around", flexShrink:0, gap:"3px", alignItems:"flex-end"}}>
                          <Box sx={{
                            fontSize:"19px",
                            color:"text.black",
                            fontWeight:500
                          }}>
                            {item?.passedCounter}
                          </Box>
                          <Box sx={{
                            fontSize:"13px",
                            color:"text.primary",
                            fontWeight:400
                          }}>
                            Réussis
                          </Box>
                        </Box>
                      </Box>
                    </Hidden>
                  </Box>
                  <Hidden smDown>
                    <Box sx={{display:"flex", gap:"35px", userSelect:"none"}}>
                      <Box sx={{display:"flex", flexDirection:"column", justifyContent:"center", flexShrink:0}}>
                        <Box sx={{
                          fontSize:"32px",
                          color:"text.black",
                          fontWeight:500
                        }}>
                          {item?.invitedCounter}
                        </Box>
                        <Box sx={{
                          fontSize:"14px",
                          color:"text.primary",
                          fontWeight:400
                        }}>
                          Invités >
                        </Box>
                      </Box>
                      <Box sx={{display:"flex", flexDirection:"column", justifyContent:"center", flexShrink:0}}>
                        <Box sx={{
                          fontSize:"32px",
                          color:"text.black",
                          fontWeight:500
                        }}>
                          {item?.completedCounter}
                        </Box>
                        <Box sx={{
                          fontSize:"14px",
                          color:"text.primary",
                          fontWeight:400
                        }}>
                          Complétés >
                        </Box>
                      </Box>
                      <Box sx={{display:"flex", flexDirection:"column", justifyContent:"center", flexShrink:0}}>
                        <Box sx={{
                          fontSize:"32px",
                          color:"text.black",
                          fontWeight:500
                        }}>
                          {item?.passedCounter}
                        </Box>
                        <Box sx={{
                          fontSize:"14px",
                          color:"text.primary",
                          fontWeight:400
                        }}>
                          Réussis >
                        </Box>
                      </Box>
                    </Box>
                  </Hidden>
                </Box>
              </Box>
            )
          })}
        </Box>
      }
      {(isLoaded === true && scans?.length === 0) &&
        <Box sx={{display:"flex",  flexDirection:"column", flex:1}}>
          <Box sx={{
            background:"white",
            border:"1px solid #E7E7E7",
            py : ["70px", "50px", "40px"],
            display:"flex",
            flexDirection:"column",
            alignItems:"center",
            gap:"20px"
          }}>
            <Box sx={{
              fontSize:["24px", "32px", "32px"],
              fontWeight : 500,
              textAlign:"center",
            }}>Créer votre premier Scan</Box>
            <Box sx={{
              fontSize:"15px",
              fontWeight : 500,
              color:"text.primary",
              maxWidth:"500px",
              textAlign:"center",
            }}>
              Quelques étapes très rapides, avec une description ou une offre d'emploi PDF !
            </Box>
            <Button
              color="primary"
              size="large"
              type="submit"
              variant="contained"
              endIcon={<ChevronRightIcon/>}
              onClick={() => {
                navigate('/app/createScan')
              }}
            >
              J'y vais !
            </Button>
          </Box>
        </Box>
      }
    </PageContentWrapper>
  )
};

export default RecruiterScans;
